export const paths = {
  index: '/',
  auth: {
    index: '/auth',
    login: '/auth/login',
    signup: '/auth/signup',
    verifyEmail: '/auth/verify-email',
    resetPassword: '/auth/reset-password',
    yandexId: '/auth/yandex-id',
  },
  home: {
    index: '/expert-list',
  },
  expertList: {
    index: '/expert-list',
  },
  dashboard: {
    index: '/dashboard',
  },
  dialogHistory: {
    index: '/dialog-history',
  },
  activeDialogs: {
    index: '/active-dialogs',
  },
  pricing: {
    index: '/pricing',
  },
  analytics: {
    index: '/analytics',
  },
  administration: {
    index: '/administration',
    users: '/administration/users',
    settings: '/administration/settings',
  },
  401: '/401',
  404: '/404',
  500: '/500',
};
